import { generateItems } from 'domain/common';
import { Enterprise } from 'domain/lib';
import { field } from 'cpcs-reconnect';

const { actions, selectors, reducer } = generateItems('Enterprise', Enterprise);

export { actions, selectors, reducer };

export const enterprise = field('enterprise');
